"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortCompanyEnum = void 0;
var SortCompanyEnum;
(function (SortCompanyEnum) {
    SortCompanyEnum["NAME"] = "name";
    SortCompanyEnum["DATE"] = "dateCreated";
})(SortCompanyEnum || (exports.SortCompanyEnum = SortCompanyEnum = {}));
